import L from "leaflet";
import { Controller } from "stimulus";

const markerIcon = L.icon({
  iconUrl: "/icons/marker-icon-2x.png",
  iconSize: [25, 41],
});

export default class extends Controller {
  static values = { latitude: Number, longitude: Number, route: Array };

  connect() {
    const map = L.map(this.element, { zoomControl: false, attributionControl: false });
    L.tileLayer(
      "https://api.maptiler.com/maps/basic-v2/{z}/{x}/{y}.png?key=Mo18Hv7gYYAKwx9mN7wz"
    ).addTo(map);
    L.control
      .zoom({
        position: "bottomright",
      })
      .addTo(map);
    if (this.hasRouteValue) {
      const line = L.polyline(
        this.routeValue.map(([longitude, latitude]) => [latitude, longitude])
      ).addTo(map);
      map.fitBounds(line.getBounds());
    } else if (this.hasLatitudeValue) {
      const location = [this.latitudeValue, this.longitudeValue];
      map.setView(location, 8);
      L.marker(location, { icon: markerIcon }).addTo(map);
    } else {
      map.setView([20, 0], 2);
    }
  }
}
